/**
 * "Buy it now": adds the current product form's selection to the cart, syncs any
 * gift-with-purchase lines (assets/gift-with-purchase.js, via window.SBGiftSync) and
 * any checked accessory add-ons (assets/sb-accessory-addons.js, via
 * window.SBAddSelectedAccessories) the same way the regular Add to cart flow does,
 * then redirects to checkout. All network calls are awaited before navigating —
 * checkout is a full page unload, so an in-flight fetch that hasn't resolved yet
 * would get cancelled by the browser and the gift/accessory would be missing.
 * Deliberately independent of product-form.js (which handles the regular Add to cart
 * button + cart drawer) so this stays a plain, isolated listener.
 */
(function () {
  'use strict';

  function showError(form, message) {
    var wrapper = form.closest('.product-form')?.querySelector('.product-form__error-message-wrapper');
    var messageEl = wrapper?.querySelector('.product-form__error-message');
    if (messageEl) messageEl.textContent = message;
    if (wrapper) wrapper.removeAttribute('hidden');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sb-buy-now]');
    if (!button || button.disabled) return;

    var form = document.getElementById(button.dataset.formId);
    if (!form) return;

    event.preventDefault();

    var wrapper = form.closest('.product-form')?.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.setAttribute('hidden', '');

    button.disabled = true;
    button.classList.add('loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(form, result.data.description || result.data.message);
          button.disabled = false;
          button.classList.remove('loading');
          return;
        }
        return (typeof window.SBGiftSync === 'function' ? window.SBGiftSync() : Promise.resolve())
          .catch(function (error) {
            // A failed gift sync shouldn't block checkout — the customer still gets the
            // item they actually clicked buy on.
            console.error(error);
          })
          .then(function () {
            return typeof window.SBAddSelectedAccessories === 'function'
              ? window.SBAddSelectedAccessories()
              : Promise.resolve();
          })
          .catch(function (error) {
            // Same reasoning as the gift sync above — a failed accessory add shouldn't
            // block checkout on the host product the customer already paid to add.
            console.error(error);
          })
          .then(function () {
            window.location.href = window.Shopify.routes.root + 'checkout';
          });
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('loading');
      });
  });
})();
